// extracted by mini-css-extract-plugin
export var animationContainer = "_gb-0";
export var asteriskIcon = "_gb-8";
export var conversationLeftSection = "_gb-4";
export var conversationListItem = "_gb-3";
export var conversationMiddleSection = "_gb-5";
export var conversationRightSection = "_gb-6";
export var detailsContent = "_gb-1";
export var listContainer = "_gb-7";
export var modalContent = "_gb-2";